import { render, staticRenderFns } from "./get_cloudapp_button.vue?vue&type=template&id=f04c520c&scoped=true&"
import script from "./get_cloudapp_button.vue?vue&type=script&lang=js&"
export * from "./get_cloudapp_button.vue?vue&type=script&lang=js&"
import style0 from "./get_cloudapp_button.vue?vue&type=style&index=0&id=f04c520c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c520c",
  null
  
)

export default component.exports